export const QA_QUOTES = [
  'Quality is not an act, it is a habit. - Aristotle',
  'Testing leads to failure, and failure leads to understanding. - Burt Rutan',
  'The bitterness of poor quality remains long after the sweetness of low price is forgotten. - Benjamin Franklin',
  'Quality is never an accident; it is always the result of high intention. - John Ruskin',
  'It is not the strongest of the species that survives, but the one most responsive to change. - Charles Darwin',
];
